function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import highlightReducer from './highlightReducer';
import getDisplayValue from './lib/getDisplayValue';
import flattenOptions from './lib/flattenOptions';
import groupOptions from './lib/groupOptions';
import getNewValue from './lib/getNewValue';
import getOption from './lib/getOption';
import doSearch from './search';
export default function useSelect(_ref) {
  var _ref$value = _ref.value,
    defaultValue = _ref$value === void 0 ? null : _ref$value,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple,
    _ref$search = _ref.search,
    canSearch = _ref$search === void 0 ? false : _ref$search,
    _ref$fuse = _ref.fuse,
    fuse = _ref$fuse === void 0 ? false : _ref$fuse,
    defaultOptions = _ref.options,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$getOptions = _ref.getOptions,
    getOptions = _ref$getOptions === void 0 ? null : _ref$getOptions,
    _ref$allowEmpty = _ref.allowEmpty,
    allowEmpty = _ref$allowEmpty === void 0 ? true : _ref$allowEmpty,
    _ref$closeOnSelect = _ref.closeOnSelect,
    closeOnSelect = _ref$closeOnSelect === void 0 ? true : _ref$closeOnSelect,
    _ref$closable = _ref.closable,
    closable = _ref$closable === void 0 ? true : _ref$closable;
  var ref = useRef(null);
  var flatDefaultOptions = useMemo(function () {
    return flattenOptions(defaultOptions);
  }, [defaultOptions]);
  var _useState = useState({
      flat: [],
      addedOptions: [],
      value: defaultValue,
      search: '',
      focus: false,
      searching: false,
      highlighted: -1,
      changed: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var flat = state.flat,
    addedOptions = state.addedOptions,
    value = state.value,
    search = state.search,
    focus = state.focus,
    searching = state.searching,
    highlighted = state.highlighted;
  var option = useMemo(function () {
    var newOption = getOption(value, [].concat(_toConsumableArray(flatDefaultOptions), _toConsumableArray(addedOptions)));
    if (!newOption && !allowEmpty && !multiple) {
      var _flatDefaultOptions = _slicedToArray(flatDefaultOptions, 1);
      newOption = _flatDefaultOptions[0];
    }
    return newOption;
  }, [value, flatDefaultOptions, addedOptions, allowEmpty, multiple]);
  var options = useMemo(function () {
    return groupOptions(flat);
  }, [flat]);
  var displayValue = useMemo(function () {
    return getDisplayValue(option);
  }, [option]);
  var onBlur = useCallback(function () {
    setState(function (oldState) {
      return _objectSpread(_objectSpread({}, oldState), {}, {
        focus: false,
        search: '',
        flat: flatDefaultOptions,
        highlighted: -1
      });
    });
    if (ref.current) {
      ref.current.blur();
    }
  }, [flatDefaultOptions, ref]);
  var setFocus = function setFocus(newFocus) {
    return setState(function (oldState) {
      return _objectSpread(_objectSpread({}, oldState), {}, {
        focus: newFocus
      });
    });
  };
  var onClick = function onClick() {
    return setFocus(!focus);
  };
  var onFocus = function onFocus() {
    return setFocus(true);
  };
  var onSelect = useCallback(function (id) {
    setState(function (prevState) {
      var prevFlat = prevState.flat,
        prevHighlighted = prevState.highlighted; // eslint-disable-next-line no-underscore-dangle,eqeqeq

      var item = id ? prevFlat.find(function (i) {
        return i.value == id;
      }) : prevFlat[prevHighlighted];
      if (!item) {
        return prevState;
      }
      var values = getNewValue(item.value, prevState.value, multiple);
      var newOptions = getOption(values, prevFlat);
      return _objectSpread(_objectSpread({}, prevState), {}, {
        addedOptions: multiple ? newOptions : [newOptions],
        value: values,
        changed: [values, newOptions]
      });
    });
  }, [multiple]);
  var onMouseDown = useCallback(function (e) {
    e.preventDefault();
    if (closeOnSelect && ref.current) {
      ref.current.blur();
    }
    onSelect(e.currentTarget.value);
  }, [onSelect, closeOnSelect]);
  var onKeyDown = useCallback(function (e) {
    var key = e.key;
    if (key === 'ArrowDown' || key === 'ArrowUp') {
      e.preventDefault();
      setState(function (oldState) {
        return _objectSpread(_objectSpread({}, oldState), {}, {
          highlighted: highlightReducer(oldState.highlighted, {
            key: key,
            options: oldState.flat
          })
        });
      });
    }
  }, []);
  var onKeyPress = useCallback(function (_ref2) {
    var key = _ref2.key;
    if (key === 'Enter') {
      onSelect();
      if (closable && closeOnSelect) {
        onBlur();
      }
    }
  }, [onSelect, closeOnSelect, onBlur, closable]);
  var onKeyUp = useCallback(function (_ref3) {
    var key = _ref3.key;
    if (key === 'Escape') {
      onBlur();
    }
  }, [onBlur]);
  var onSearch = function onSearch(_ref4) {
    var target = _ref4.target;
    var inputVal = target.value;
    var newState = {
      search: inputVal
    };
    var searchableOption = flatDefaultOptions;
    if (getOptions && inputVal.length) {
      newState.searching = true;
      searchableOption = getOptions(inputVal);
    }
    setState(function (oldState) {
      return _objectSpread(_objectSpread({}, oldState), newState);
    });
    Promise.resolve(searchableOption).then(function (foundOptions) {
      var newOptions = foundOptions;
      if (inputVal.length) {
        newOptions = doSearch(inputVal, foundOptions, fuse);
      }
      setState(function (oldState) {
        return _objectSpread(_objectSpread({}, oldState), {}, {
          flat: newOptions === false ? foundOptions : newOptions,
          searching: false
        });
      });
    })["catch"](function () {
      return setState(function (oldState) {
        return _objectSpread(_objectSpread({}, oldState), {}, {
          flat: flatDefaultOptions,
          searching: false
        });
      });
    });
  };
  var valueProps = {
    tabIndex: '0',
    readOnly: !canSearch,
    onChange: canSearch ? onSearch : null,
    disabled: disabled,
    onMouseDown: onClick,
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyPress: onKeyPress,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    ref: ref
  };
  var optionProps = useMemo(function () {
    return {
      tabIndex: '-1',
      onMouseDown: onMouseDown,
      onKeyDown: onKeyDown,
      onKeyPress: onKeyPress,
      onBlur: onBlur
    };
  }, [onMouseDown, onKeyDown, onKeyPress, onBlur]);
  useEffect(function () {
    setState(function (oldState) {
      return _objectSpread(_objectSpread({}, oldState), {}, {
        value: defaultValue
      });
    });
  }, [defaultValue]);
  useEffect(function () {
    setState(function (oldState) {
      return _objectSpread(_objectSpread({}, oldState), {}, {
        flat: flatDefaultOptions
      });
    });
  }, [flatDefaultOptions]);
  useEffect(function () {
    if (state.changed !== false) {
      setState(function (oldState) {
        return _objectSpread(_objectSpread({}, oldState), {}, {
          changed: false
        });
      });
      onChange.apply(void 0, _toConsumableArray(state.changed));
    }
  }, [state.changed, onChange]);
  return [{
    value: option,
    highlighted: highlighted,
    options: options,
    disabled: disabled,
    displayValue: displayValue,
    focus: focus,
    search: search,
    searching: searching
  }, valueProps, optionProps, function (newValue) {
    return setState(function (oldState) {
      return _objectSpread(_objectSpread({}, oldState), {}, {
        value: newValue
      });
    });
  }];
}